export default __webpack_public_path__ + "static/media/adjust_icon.ba94d6dd.svg";